import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// When used from code evaluated before the app is created (e.g. axios interceptors,
// router guards), pass this pinia instance as an argument: useXxxStore(pinia)
export default pinia
